<template>
    <div class="wrapper">
        <notifications></notifications>
        <side-bar>
            <template slot-scope="props" slot="links">
                <sidebar-item
                    :link="{
                        name: $t('sideMenu.myApps'),
                        icon: 'ai ai-apps text-primary',
                        path: '/applications',
                    }"
                >
                </sidebar-item>

                <sidebar-item
                    :link="{
                        name: $t('sideMenu.myAccount'),
                        icon: 'ai ai-account text-warning',
                        path: '/my-account',
                    }"
                >
                </sidebar-item>

                <sidebar-item
                    v-if="user.role === 'admin'"
                    :link="{
                        name: $t('sideMenu.logs'),
                        icon: 'ai ai-logs text-warning',
                        path: '/logs',
                    }"
                >
                </sidebar-item>
            </template>

            <template v-if="user.role === 'admin'" slot="hotel-settings">
                <hr class="my-3" />
                <h6 class="navbar-heading p-0 text-muted">
                    {{ $t("sideMenu.hotelSettings") }}
                </h6>

                <ul class="navbar-nav mb-md-3">
                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.invoices'),
                            icon: 'ai ai-docs text-warning',
                            path: '/invoices',
                        }"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.contacts'),
                            icon: 'ai ai-docs text-warning',
                            path: '/contacts',
                        }"
                    >
                    </sidebar-item>
                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.hotelTags'),
                            icon: 'ai ai-docs text-warning',
                            path: '/hotel-tags',
                        }"
                    >
                    </sidebar-item>
                </ul>
            </template>

            <template v-if="user.role === 'admin'" slot="user-management">
                <hr class="my-3" />
                <h6 class="navbar-heading p-0 text-muted">
                    {{ $t("sideMenu.userManagement") }}
                </h6>

                <ul class="navbar-nav mb-md-3">
                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.inviteNewUser'),
                            icon: 'ai ai-user-add text-pink',
                            path: '/invite-user',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.users'),
                            icon: 'ai ai-user-edit text-info',
                            path: '/users',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.managePermissions'),
                            icon: 'ai ai-user-star text-success',
                            path: '/manage-permissions',
                        }"
                    >
                    </sidebar-item>
                </ul>
            </template>

            <template v-if="!!user.assist_admin" slot="assist-admin">
                <hr class="my-3" />
                <h6 class="navbar-heading p-0 text-muted">Assist Admin</h6>

                <ul class="navbar-nav mb-md-3">
                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.manageHotelGroups'),
                            icon: 'ai ai-hotel-group text-primary',
                            path: '/assist-admin/hotel-groups',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.manageHotels'),
                            icon: 'ai ai-hotel text-yellow',
                            path: '/assist-admin/hotels',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.manageApplications'),
                            icon: 'ai ai-apps-2 text-danger',
                            path: '/assist-admin/applications',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.manageInvoices'),
                            icon: 'ai ai-apps-2 text-danger',
                            path: '/assist-admin/invoices',
                        }"
                    >
                    </sidebar-item>

                    <sidebar-item
                        :link="{
                            name: $t('sideMenu.tagManagement'),
                            icon: 'ai ai-apps-2 text-danger',
                            path: '/assist-admin/tag-management',
                        }"
                    >
                    </sidebar-item>
                </ul>
            </template>
        </side-bar>
        <div class="main-content">
            <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

            <div @click="$sidebar.displaySidebar(false)">
                <fade-transition
                    :duration="200"
                    origin="center top"
                    mode="out-in"
                >
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-new */
import { mapGetters } from "vuex";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        DashboardContent,
        FadeTransition,
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    methods: {
        initScrollbar() {
            let isWindows = navigator.platform.startsWith("Win");
            if (isWindows) {
                initScrollbar("scrollbar-inner");
            }
        },
    },
    mounted() {
        this.initScrollbar();
    },
};
</script>
<style lang="scss">
.text-blue-martina {
    color: #12cbc4;
}

.text-pigment {
    color: #ea2027;
}

.text-merchant-marine-blue {
    color: #0652dd;
}

.text-circumorbital-ring {
    color: #5758bb;
}
</style>
